import React from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Option } from 'app/types';
import SelectInput from './components/SelectInput';
import { gamesSelectReducer, gamesSelectSlice } from './redux/slice';
import { gamesSelectSaga } from './redux/saga';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { selectDirection } from 'styles/theme/slice';
import { useSelector } from 'react-redux';

interface GameSelectProps {
    label?: string;
    value?: Option;
    onChange?: (newValue?: Option | null) => void;
    isFieldReq?: boolean;
    mainStyle?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    isLoading?: boolean;
    disabled?: boolean;
    error?: string;
}

export default function GameSelect({
    value,
    onChange,
    isFieldReq=true,
    mainStyle,
    labelStyle,
    isLoading,
    disabled,
    error,
} : GameSelectProps) {
    useInjectReducer({ key: gamesSelectSlice, reducer: gamesSelectReducer });
    useInjectSaga({ key: gamesSelectSlice, saga: gamesSelectSaga });
    const { t } = useTranslation();
  const direction = useSelector(selectDirection);
    return (
        <Box
            sx={{ 
                marginBottom: "10px",
                width: "100%",
            }} 
            style={mainStyle}
        >
           <Typography
                sx={{
                    
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    display: "-webkit-box",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    ...labelStyle
                }}
                >
                {t("COMMON.LABELS.GAME_NAME")}
                {isFieldReq && <span style={{ color: '#ff0000' }}> *</span>}
            </Typography>
            <SelectInput 
                value={value}
                onChange={onChange}
                isLoading={isLoading}
                disabled={disabled}
                error={error}
            />
        </Box>
    )
}
